import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Phone } from 'lucide-react';
import content from '../content/parkingPages.json';
import '../parking-content.css';

export { PageMetadata } from './ParkingMetadata';
export const parkingPages = content.pages;

export const BookingBar = () => {
  useEffect(() => {
    document.body.classList.add('parking-booking-active');
    return () => document.body.classList.remove('parking-booking-active');
  }, []);
  return (
  <aside className="parking-booking-bar" aria-label="Reserva de parking" data-testid="parking-booking-bar">
    <span data-testid="parking-booking-bar-caption">Valet en Madrid-Barajas</span>
    <Link to="/reservar" className="parking-reserve" data-testid="sticky-reserve">
      Reservar <ArrowRight size={18} aria-hidden="true" />
    </Link>
  </aside>
  );
};

export const ParkingFaq = () => (
  <section className="parking-content-section" lang="es" aria-labelledby="parking-faq-title" data-testid="parking-faq-section">
    <h2 id="parking-faq-title" data-testid="parking-faq-title">Antes de reservar: preguntas frecuentes</h2>
    <div className="parking-faq">
      {content.faq.map((item, index) => (
        <details key={item.question} data-testid={`parking-faq-${index + 1}`}>
          <summary data-testid={`parking-faq-question-${index + 1}`}>{item.question}</summary>
          <p data-testid={`parking-faq-answer-${index + 1}`}>{item.answer}</p>
        </details>
      ))}
    </div>
    <p>¿Necesitas confirmar algún detalle?{' '}
      <a href="tel:+34641243287" data-testid="parking-faq-phone">Llama al 641 243 287</a>{' '}
      o consulta los <Link to="/terminos" data-testid="parking-faq-terms">términos del servicio</Link>.
    </p>
  </section>
);

export const ParkingNavigation = ({ currentSlug }) => (
  <nav className="parking-content-section" lang="es" aria-label="Información sobre parking en Barajas" data-testid="parking-navigation">
    <h2 data-testid="parking-navigation-title">Prepara tu viaje desde Barajas</h2>
    <div className="parking-page-links">
      {content.pages.filter(page => page.slug !== currentSlug).map(page => (
        <Link key={page.slug} to={`/${page.slug}`} data-testid={`parking-link-${page.slug}`}>
          {page.heading}<ArrowRight size={18} aria-hidden="true" />
        </Link>
      ))}
    </div>
  </nav>
);

export const ParkingHeader = () => (
  <header className="parking-information-header">
    <Link to="/" aria-label="Pléyades Parking, inicio" data-testid="parking-home-link">PLÉYADES PARKING</Link>
    <a href="tel:+34641243287" data-testid="parking-header-phone"><Phone size={16} aria-hidden="true" />641 243 287</a>
  </header>
);